import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { environment } from '@environment';
import { goToWhatsappSupportHelper } from '@app/helpers/open-url.helper';

@Component({
  selector: 'app-support-info',
  templateUrl: './support-info.component.html',
  styleUrls: ['./support-info.component.sass'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SupportInfoComponent {

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly icons = Icon;

  constructor() { }

  get supportPhone(): string {
    return `<strong>(${environment.countryInfo.phone_prefix}) ${environment.countryInfo.support_phone}</strong>`;
  }

  get agentImage(): string {
    return 'agente-soporte.png';
  }

  public goToWhatsappSupport(): void {
    goToWhatsappSupportHelper();
  }

}
